<template>
  <v-alert
    border="left"
    v-model="alertdata.show"
    dismissible
    :type="alertdata.type">
    <p v-html="alertdata.text" class="my-0 py-0"></p>
  </v-alert>
</template>
<script>
  export default {
    props: ['alertdata'],
    data: () => ({
    }),
  };
</script>